import React, { useEffect, useState } from 'react'
import CustomTable from '../../components/customTable/CustomTable'
import { getMasterItems, toggleMasterStatus } from './slice/slice'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../components/loader/Loader'
import { toast } from 'react-toastify';

function MasterCategories() {
    const dispatch = useDispatch()
    const { isLoading, getMasterItemsDetails } = useSelector(state => state.CategoriesSlice);
    const [toggleSuccess, setToggleSuccess] = useState(false);
    const tableHeaders = ['donotshowID', 'Master Category'];

    useEffect(() => {
        dispatch(getMasterItems());
    }, [dispatch, toggleSuccess]);

    const handleToggleClick = (rowData) => {
        const queryParam = `?id=${rowData.id}`
        dispatch(toggleMasterStatus(queryParam))
            .unwrap()
            .then((res) => {
                toast.success(res?.message);
                setToggleSuccess(!toggleSuccess);
            })
            .catch((error) => {
                toast.error(error?.message);
            });
    };

    return (
        <>
            {isLoading && <Loader />}
            <div style={{ minHeight: '95vh' }} className='main-Page-css'>
                <div className='main-page-title'>Categories</div>
                <CustomTable
                    showTitle 
                    titlehead='Master Categories list'
                    data={getMasterItemsDetails?.map(item => ({
                        id: item.id,
                        mastercategory: {
                            icon: `${process.env.REACT_APP_IMAGE_URL}/${item?.icon}`,
                            text: item.name,
                        },
                        is_active: item.is_active
                    })) || []}
                    headers={tableHeaders}
                    showIcon={true}
                    sliderHeaderText='Action'
                    showActions
                    showSlider2={true}
                    showtablecss={true}
                    onToggleClick={(rowdata) => handleToggleClick(rowdata)}
                />
            </div>
        </>
    )
}

export default MasterCategories;
